// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5679":"676dcc61","7927":"ba518849"}[chunkId] + ".chunk.css";
};